export default function Footer() {
  const imgPath = "/assets/imgs/";
  // const imgPath = process.env.ASSET_URL + '/assets/imgs/logo.png';

  return (
    <div>
      <footer className="bg-dark py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 mb-3">
              <div className="text-center">
                <a className="logo logo-footer" href="#">
                  <img
                    src={imgPath + "white-logo-vmf.png"}
                    height={78}
                    alt=""
                  />
                </a>
                <p className="text-muted para-desc mx-auto mt-3">
                  {" "}
            
                </p>
                <ul className="list-unstyled social-icon social mb-0 mt-4 hide">
                  <li className="list-inline-item">
                    <a href="https://www.facebook.com/" className="rounded">
                      <i className="bi bi-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://www.instagram.com/" className="rounded">
                      <i className="bi bi-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://twitter.com/" className="rounded">
                      <i data-feather="twitter" className="bi bi-twitter" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://linkedin.com/" className="rounded">
                      <i data-feather="linkedin" className="bi bi-linkedin" />
                    </a>
                  </li>
                </ul>
                {/*end icon*/}
              </div>
            </div>
          </div>
        </div>
        {/* Back to top */}
        <a href="#" className="back-to-top" id="back-to-top" title="Top">
          <i className="mdi mdi-arrow-up icons bg-light text-dark"> </i>
        </a>
        {/* Back to top */}
      </footer>
      {/*end footer*/}
      <footer className="footer-bar bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <p className="mb-0 footer-text para-desc mx-auto">
                © <span className="text-reset">VMF DAO</span>. <a href="https://forms.office.com/pages/responsepage.aspx?id=BtYcRvY4HE6sJAUw34uh2hF_PovJ841Gvy2GTTPtKAtUNEFFS0JKVUo3VVhNNzQwRzlUUjdHSDdGNi4u&origin=QRCode" target="_blank">| Feedback |</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
